import React from 'react';
import { BrowserRouter } from 'react-router';

const withRouting = (WrappedComponent: React.ComponentType<any>) => {
  const WithRoutingComponent: React.FC<any> = props => (
    <BrowserRouter>
      <WrappedComponent {...props} />
    </BrowserRouter>
  );
  WithRoutingComponent.displayName = `withRouting(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithRoutingComponent;
};

export default withRouting;
